import React, { useState } from 'react';

import { ActionPanelCard } from '@eika/action-panel-card';
import { Button } from '@eika/button';
import { IconTypes } from '@eika/icon';

import AvtaleGiroItemSkeleton from '../../components/AvtaleGiroItem/AvtaleGiroItemSkeleton';
import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import { useConfig } from '../../defaultConfig';
import { useAvtaleGiroProposals, useRefreshAvtalegiro } from '../../fetchHooks/useAvtalegiro';
import type { AvtalegiroProposal } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';
import AvtaleGiroProposalsDetails from './AvtaleGiroProposalsDetails';

const AvtaleGiroProposalList: React.FC = () => {
    const translated = useTranslation();
    const [avtaleGiroProposal, setAvtaleGiroProposal] = useState<AvtalegiroProposal>();
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const { featureToggles } = useConfig();

    const {
        data: avtalegiroProposals = [],
        invalidateQuery,
        error,
        isLoading: isLoadingAvtaleGiroAgreement,
        refetch: refreshDetails,
    } = useAvtaleGiroProposals(featureToggles.enableAvtaleGiroProposals);

    const refreshAvtalegiro = useRefreshAvtalegiro();
    const isLoading = isLoadingAvtaleGiroAgreement;

    const handleSelectAvtaleGiroProposals = (proposal: AvtalegiroProposal) => {
        setShowDetails(true);
        setAvtaleGiroProposal(proposal);
    };

    const resetAvtalegiroProposal = () => {
        setAvtaleGiroProposal(undefined);
    };

    const hasAvtaleGiroProposals = avtalegiroProposals && avtalegiroProposals.length !== 0;

    if (!featureToggles.enableAvtaleGiroProposals) {
        return null;
    }

    if (error) {
        return (
            <ErrorCardWrapper exception={error}>
                <Button onClick={() => refreshDetails()}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        );
    }

    if (isLoading) {
        return (
            <>
                <h2 className="avtalegiro__proposals__title typography-h3">{translated.avtaleGiroProposals.title}</h2>
                <AvtaleGiroItemSkeleton />
            </>
        );
    }

    if (hasAvtaleGiroProposals) {
        return (
            <>
                <h2 className="avtalegiro__proposals__title typography-h3">{translated.avtaleGiroProposals.title}</h2>
                <ul className="avtalegiro_propo_list">
                    <div className="avtalegiro__proposals">
                        {avtalegiroProposals.map((avtaleGiroProposal) => (
                            <ActionPanelCard
                                title={avtaleGiroProposal.creditorName}
                                key={avtaleGiroProposal.id.toString()}
                                icon={IconTypes.PLUSS_24}
                                onClick={() => handleSelectAvtaleGiroProposals(avtaleGiroProposal)}
                                data-track-id={paymentTrackIDs.avtalegiro.proposalAgreement}
                                data-track-linkname="avtalegiro-proposal-agreement"
                            />
                        ))}
                    </div>
                </ul>
                {showDetails && avtaleGiroProposal && (
                    <AvtaleGiroProposalsDetails
                        avtaleGiroProposal={avtaleGiroProposal}
                        show={showDetails}
                        setShow={setShowDetails}
                        onClose={resetAvtalegiroProposal}
                        refreshAvtaleGiroProposal={invalidateQuery}
                        refreshAvtalegiro={refreshAvtalegiro}
                    />
                )}
            </>
        );
    }

    return <></>;
};
export default AvtaleGiroProposalList;
